import http from '@/core/http'
import moment from 'moment'

const url = 'usuarios-bonus-web'

const state = {
  itens: [],
  totalItens: 0
}

const actions = {
  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, { params: {...payload },  order: { id: 'desc' } })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },
  
  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete(url, {params: payload})
    return Promise.resolve(result)
  },

  getItem: ({ commit }, payload) => {
    commit('LISTA_ITEM', payload)
  },

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  }
}

const mutations = {

  'LISTA_ITENS' (state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM' (state, payload) {
    state.item = Object.assign({}, payload)
    state.item.dtEnd = moment(state.item.dtEnd, 'DD/MM/YYYY HH:mm').toDate()
    state.item.dtStart = moment(state.item.dtStart, 'DD/MM/YYYY HH:mm').toDate()
  },

  'LIMPAR_ITEM' (state) {
    state.item = {
      aliquot: '',
      name: '',
      cod: '',
      dtEnd: '',
      dtStart: '',
      entityId: '',
      sizeLimit: '',
      value: ''
    }
  },
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  item: state => state.item,
}

export default { namespaced: true, state, actions, mutations, getters }